import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    tap({
      error: (err: HttpErrorResponse) => {
        const isAuthRequest = req.url.includes('/auth/') || req.url.includes('/users/login');
        if ((err.status === 401 || err.status === 403) && !isAuthRequest) {
          authService.logout();
          void router.navigate(['/']);
        }
      },
    }),
  );
};
